const translation = {
  pageTitle: 'はじめましょう！👋',
  welcome: 'Dify へようこそ。続行するにはログインしてください。',
  email: 'メールアドレス',
  emailPlaceholder: 'メールアドレスを入力してください',
  password: 'パスワード',
  passwordPlaceholder: 'パスワードを入力してください',
  name: 'ユーザー名',
  namePlaceholder: 'ユーザー名を入力してください',
  forget: 'パスワードをお忘れですか？',
  signBtn: 'サインイン',
  sso: 'SSO に続ける',
  installBtn: 'セットアップ',
  setAdminAccount: '管理者アカウントの設定',
  setAdminAccountDesc: 'アプリケーションの作成や LLM プロバイダの管理など、管理者アカウントの最大権限を設定します。',
  createAndSignIn: '作成してサインイン',
  oneMoreStep: 'あと一歩',
  createSample: 'この情報を基に、サンプルアプリケーションを作成します',
  invitationCode: '招待コード',
  invitationCodePlaceholder: '招待コードを入力してください',
  interfaceLanguage: 'インターフェース言語',
  timezone: 'タイムゾーン',
  go: 'Dify へ移動',
  sendUsMail: '自己紹介をメールで送信し、招待リクエストを処理します。',
  acceptPP: 'プライバシーポリシーを読み、同意します',
  reset: 'パスワードをリセットするには、次のコマンドを実行してください',
  withGitHub: 'GitHub で続行',
  withGoogle: 'Google で続行',
  rightTitle: 'LLM のフルポテンシャルを解き放つ',
  rightDesc: '魅力的で操作可能で改善可能な AI アプリケーションを簡単に構築します。',
  tos: '利用規約',
  pp: 'プライバシーポリシー',
  tosDesc: 'サインアップすることで、以下に同意するものとします',
  goToInit: 'アカウントを初期化していない場合は、初期化ページに移動してください',
  dontHave: 'お持ちでない場合',
  invalidInvitationCode: '無効な招待コード',
  accountAlreadyInited: 'アカウントは既に初期化されています',
  forgotPassword: 'パスワードを忘れましたか？',
  resetLinkSent: 'リセットリンクが送信されました',
  sendResetLink: 'リセットリンクを送信',
  backToSignIn: 'サインインに戻る',
  forgotPasswordDesc: 'パスワードをリセットするためにメールアドレスを入力してください。パスワードのリセット方法に関する指示が記載されたメールを送信します。',
  checkEmailForResetLink: 'パスワードリセットリンクを確認するためにメールを確認してください。数分以内に表示されない場合は、スパムフォルダーを確認してください。',
  passwordChanged: '今すぐサインイン',
  changePassword: 'パスワードを変更する',
  changePasswordTip: 'アカウントの新しいパスワードを入力してください',
  invalidToken: '無効または期限切れのトークン',
  confirmPassword: 'パスワードを確認',
  confirmPasswordPlaceholder: '新しいパスワードを確認してください',
  passwordChangedTip: 'パスワードが正常に変更されました',
  error: {
    emailEmpty: 'メールアドレスは必須です',
    emailInValid: '有効なメールアドレスを入力してください',
    nameEmpty: '名前は必須です',
    passwordEmpty: 'パスワードは必須です',
    passwordLengthInValid: 'パスワードは 8 文字以上でなければなりません',
    passwordInvalid: 'パスワードは文字と数字を含み、長さは 8 以上である必要があります',
    registrationNotAllowed: 'アカウントが見つかりません。登録するためにシステム管理者に連絡してください。',
  },
  license: {
    tip: 'GitHub のオープンソースライセンスを確認してから、Dify Community Edition を開始してください。',
    link: 'オープンソースライセンス',
  },
  join: '参加する',
  joinTipStart: 'あなたを招待します',
  joinTipEnd: 'チームに参加する',
  invalid: 'リンクの有効期限が切れています',
  explore: 'Dify を探索する',
  activatedTipStart: 'あなたは',
  activatedTipEnd: 'チームに参加しました',
  activated: '今すぐサインイン',
  adminInitPassword: '管理者初期化パスワード',
  validate: '検証',
  checkCode: {
    invalidCode: '無効なコード',
    verify: '確かめる',
    verificationCodePlaceholder: '6 桁のコードを入力してください',
    useAnotherMethod: '別の方法を使用する',
    didNotReceiveCode: 'コードが届きませんか？',
    resend: '再送',
    verificationCode: '認証コード',
    tips: '<strong>確認コードを{{email}}に送信します。</strong>',
    validTime: 'コードは 5 分間有効であることに注意してください',
    emptyCode: 'コードが必要です',
    checkYourEmail: 'メールをチェックしてください',
  },
  useVerificationCode: '確認コードを使用する',
  or: '又は',
  back: '戻る',
  resetPassword: 'パスワードのリセット',
  changePasswordBtn: 'パスワードを設定する',
  setYourAccount: 'アカウントを設定する',
  withSSO: 'SSO を続行する',
  noLoginMethod: '認証方法が構成されていません',
  backToLogin: 'ログインに戻る',
  continueWithCode: 'コードで続行',
  noLoginMethodTip: 'システム管理者に連絡して、認証方法を追加してください。',
  usePassword: 'パスワードを使用',
  sendVerificationCode: '確認コードの送信',
  enterYourName: 'ユーザー名を入力してください',
  resetPasswordDesc: 'Dify へのサインアップに使用したメールアドレスを入力すると、パスワードリセットメールが送信されます。',
  licenseLost: 'ライセンスを失った',
  licenseExpiredTip: 'ワークスペースの Dify Enterprise ライセンスの有効期限が切れています。Dify を引き続き使用するには、管理者に連絡してください。',
  licenseInactive: 'ライセンスが非アクティブです',
  licenseInactiveTip: 'ワークスペースの Dify Enterprise ライセンスが非アクティブです。Dify を引き続き使用するには、管理者に連絡してください。',
  licenseExpired: 'ライセンスの有効期限が切れています',
  licenseLostTip: 'Dify ライセンスサーバーへの接続に失敗しました。続けて Dify を使用するために管理者に連絡してください。',
  webapp: {
    noLoginMethod: 'Web アプリに対して認証方法が構成されていません',
    noLoginMethodTip: 'システム管理者に連絡して、認証方法を追加してください。',
    disabled: 'Web アプリの認証が無効になっています。システム管理者に連絡して有効にしてください。直接アプリを使用してみてください。',
  },
}

export default translation
